import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { CircularProgress, Typography } from '@mui/material';
import { FlexColumn, Flex, Button } from '@elementary/common-ui/components';
import { fontWeight, radius, space } from '@elementary/common-ui/style/utils';
import { useScim } from '../hooks/useScim';
import ProvisioningConfigDialog from './ProvisioningConfigDialog';
import ProvisioningStatusChip from './ProvisioningStatusChip';
import ProvisioningSource from './ProvisioningSource';

const SectionContainer = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.border.subtle};
  border-radius: ${radius('md')};
  padding: ${space('xxl', 'xxxl')};
  gap: ${space('lg')};
`;

const SectionHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

const HeaderLeft = styled(Flex)`
  align-items: center;
  gap: ${space('lg')};
`;

const HeaderRight = styled(Flex)`
  align-items: center;
  gap: ${space('lg')};
`;

const ConfigRow = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.palette.border.subtle};
  border-radius: ${radius('md')};
  padding: ${space('lg', 'xl')};
  justify-content: space-between;
  align-items: center;
`;

const ProvisioningSection = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const scim = useScim();

  const handleOpenDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <SectionContainer>
        <SectionHeader>
          <HeaderLeft>
            <Typography sx={{ fontWeight: fontWeight('semibold') }}>
              Provisioning
            </Typography>
          </HeaderLeft>
          <HeaderRight>
            {scim.isLoading && <CircularProgress size={14} />}
            <Button variant="outlined" onClick={handleOpenDialog}>
              Configure
            </Button>
          </HeaderRight>
        </SectionHeader>

        {scim.data && (
          <ConfigRow>
            <ProvisioningSource source={scim.data.source} />
            <ProvisioningStatusChip status={scim.data.status} />
          </ConfigRow>
        )}
      </SectionContainer>

      <ProvisioningConfigDialog open={dialogOpen} onClose={handleCloseDialog} />
    </>
  );
};

export default ProvisioningSection;
